import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login.vue'
import Credentials from '@/components/Credentials/Credentials.vue'
import CreatePassword from '@/components/CreatePassword/CreatePassword.vue'
import ForgotPassword from '@/components/ForgotPassword/ForgotPassword.vue'
import Dashboard from '@/components/Dashboard/Dashboard.vue'
import DashboardHome from '@/components/DashboardHome/DashboardHome.vue'
import UsersList from '@/components/UsersList/UsersList.vue'
import EditUser from '@/components/EditUser/EditUser.vue'
import ChangePassword from '@/components/ChangePassword/ChangePassword.vue'
import ResendWelcome from '@/components/ResendWelcome/ResendWelcome.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: 'login'
    },
    {
      path: '/login/:token?',
      name: 'login',
      component: Login,
      props: true
    },
    {
      path: '/createPassword/:token/:backurl?',
      name: 'createPassword',
      component: CreatePassword,
      props: true
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: ForgotPassword,
      props: true
    },
    {
      path: '/linkExpired',
      name: 'linkExpired',
      component: ForgotPassword
    },
    {
      path: '/changePassword',
      name: 'changePasswordNotLoggedIn',
      component: ChangePassword
    },
    {
      path: '/resendWelcome/:email/:userType',
      name: 'resendWelcome',
      component: ResendWelcome,
      props: true
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      canReuse: false,
      children: [
        {
          path: 'changePassword',
          name: 'changePassword',
          component: Credentials,
        },     
        {
          path: 'setPassword/:id',
          name: 'setPassword',
          component: Credentials,
          props: true
        },   
        {
          path: 'userslist',
          name: 'usersList',
          component: UsersList
        },
        {
          path: 'userslist/:id',
          name: 'editUser',
          component: EditUser
        },
        {
            path: '',
            name: '',
            component: DashboardHome,
        }
      ],
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js